import { DownloadUrlLink } from "~/common/components/Link";
import { trackPDPDownloadBasicFrequencies } from "~/app/analytics/ga/ga";
import { type PdpPageProductData } from "~/features/productDetails/models/PdpPageProductData";
import { useTranslation } from "react-i18next";
import { getBearingXURL } from "~/utils/url/urlUtils";
import { usePdpWebComponentUrls } from "~/features/productDetails/context/PdpWebComponentUrlsContext";

interface BearingXPdfDownloadLinkProps {
  product: Pick<PdpPageProductData, "designation">;
  bearingXDesignation: string;
}

const BearingXPdfDownloadLink = ({ product, bearingXDesignation }: BearingXPdfDownloadLinkProps) => {
  const { t } = useTranslation();
  const { bearingXUrl } = usePdpWebComponentUrls();

  const label = t("productDetailPage.downloadPdfBasicFrequencies");

  return (
    <DownloadUrlLink
      href={getBearingXURL(bearingXUrl, bearingXDesignation)}
      className={"scha__pdp__pdf-link"}
      onClick={() => trackPDPDownloadBasicFrequencies(product.designation)}
    >
      {label}
    </DownloadUrlLink>
  );
};

export default BearingXPdfDownloadLink;
